export default __webpack_public_path__ + "static/philip-66ae5b7e6a565e8c5f7a0f8bbec9e2ac.jpg";